export default __webpack_public_path__ + "b61ad00e8946eadd40a070e1679e1a7e.png";